import type { StyleProp } from '@vtex/admin-ui'
import { Text, csx } from '@vtex/admin-ui'
import React from 'react'

import { sizeToRem } from '../../../../core/theme/theme'

const containerStyles: StyleProp = {
  color: 'NEED_PERFORMANCE_REVIEW_blue',
  fontSize: sizeToRem(2),
  fontWeight: 600,
}

export type MultipleAssistancesCounterProps = {
  assistancesCount: number
  currentAssistance: number
}

export const MultipleAssistancesCounter = ({
  assistancesCount,
  currentAssistance,
}: MultipleAssistancesCounterProps) => (
  <Text variant="title2" className={csx({ containerStyles })}>
    {`${currentAssistance}/${assistancesCount} `}
    <Text
      variant="title2"
      className={csx({
        ...containerStyles,
        fontWeight: 500 /* NEED_PERFORMANCE_REVIEW */,
      })}
    >
      atendimentos
    </Text>
  </Text>
)
